import styled from 'styled-components';
import { FormGroup, Button, ControlLabel } from 'react-bootstrap';

const StyledButton = styled(Button)`
  width: 25px;
  height: 25px !important;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 0;
`;

const FlexRow = styled(FormGroup)`
  display: flex;
  align-items: center;
`;

const Col = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

const StyledControlLabel = styled(ControlLabel)`
  font-size: inherit !important;
  margin-right: 10px;
  margin-bottom: 0;
`;

const S = {
  FlexRow,
  StyledButton,
  StyledControlLabel,
  Col,
};

export default S;
